export default "__VITE_ASSET__DrtPT079__"